import React, { useEffect, useState, useRef } from 'react';
import AppBar from '@mui/material/AppBar';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Button, MenuItem, Select, Typography, useMediaQuery } from '@mui/material';
import { getAccessToken } from 'app/utils/common-utils/common-utils';
import AmyIcon from 'app/components/common/cards/chat-card/amy-icons';
import SideNavigation from 'app/components/layout/side-navigaion/side-navigation';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import PrimaryHeader from 'app/components/layout/header/primary-header';
import RecurringRangeModal from './recurring-date-range/recurring-range-modal';
import ActivityCardDetails from '../activity-details-section/activity-details-card/activity-details-card';
import {
  deleteActivityById,
  deleteActivityByIds,
  fetchActivities,
  fetchActivityDetails,
  fetchActivityDetailsUnauthorized,
  fetchRecurringDetails,
  fetchRecurringDetailsFilter,
  fetchunAuthorosiedActivities,
  fetchUnAuthRecurringDetails,
} from 'app/shared/reducers/activity-home';
import ActivityRecurringDetails from './recurring-details-card/recurring-details-card';
import RecurringDetailsSidePanel from './recurring-details-side-panel/recurring-details-side-pannel';
import toast from 'react-hot-toast';
import { updateVolunteeringEventId } from 'app/shared/reducers/activity-filter';
import { useItemId } from 'app/utils/hooks/useItemId';
import { Helmet } from 'react-helmet';
import { PayloadAction } from '@reduxjs/toolkit';
import SEO from 'app/components/common/seo';
import useMetaTagUpdater from 'app/components/metaTagUpdater';
import metaTagUpdateReverse from 'app/components/MetaTagReverse';
import axios from 'axios';

const drawerWidth = 315;
const drawerWidthSm = 248;
// interface Props {
//   window?: () => Window;
// }
export interface Activity {
  id: number;
  currentActivityVolunteer: boolean;
  category: {
    category: string;
    id: number;
    favorite: boolean;
  };
  eventParticipantsProfile: any | null;
  eventParticipantCount: number;
  activityStatus: string;
  caption: string;
  title: string;
  ageLimit: number | null;
  planningForMicroFunding: boolean;
  amountToRaise: number | null;
  postAsOrganisation: any | null;
  makeAsUrgentNeed: boolean;
  makeThisPrivateActivity: boolean;
  startDate: string;
  createdBy: number;
  createdAt: string;
  modifiedBy: number | null;
  modifiedAt: string | null;
  postedByProfileImage: string | null;
  postedBy: string;
  eventGallery: {
    link: string;
    type: string;
    thumbnail: string | null;
  }[];
  eventPlace: string;
  likeCount: number;
  msgCount: number;
  bookMark: any | null;
  starRating: number;
  shareContent: any | null;
  eventURL: string;
  online: boolean;
  participants: {
    id: number;
    name: string;
    profilePic: string | null;
    organizer: boolean;
    moderator: boolean;
    reached: boolean;
    bio: string;
    reported: boolean;
    reportedCount: number;
    resources: any[];
    organizationId: number | null;
  }[];
  latitude: string;
  longitude: string;
  resources: any[];
  instructions: string | null;
  activityStartTime: string;
  activityEndTime: string;
  currency: string | null;
  onlineUrl: string | null;
  pdfUrl: string | null;
  eventType: string;
  participant: boolean;
  hasPermission: boolean;
  ratedParticipantsCount: number;
  awesome: number;
  good: number;
  average: number;
  bad: number;
  terrible: number;
  rated: boolean;
  completedEventGallery: any | null;
  country: string;
  state: string;
  city: string;
  activityFrequencyId: number;
  customFrequency: any[];
  endDate: string;
  reported: boolean;
  lostPet: any | null;
  organizationId: number | null;
  recurringId: number;
  showLeaveActivity: boolean;
  partialParticipant: boolean;
  unit: string | null;
  bloodDonation: boolean;
  bloodType: string | null;
  activityViewCount: number;
  markAsDone: boolean;
  overallRating: number | null;
  chatable: boolean;
  liked: boolean;
  invited: boolean;
  featured: boolean;
  organiser: boolean;
  permittedToFeatured: boolean;
  satisfaction: number;
  communication: number;
  planning: number;
}

export const RecurringSection = () => {
  let token;

  const location = useLocation();
  const activityId = useItemId();
  const [activityRespectiveId, setactivityRespectiveId] = useState<any>(0);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [category, setCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [activity, setActivity] = useState<Activity | null>(null);
  const [parentActivityResponse, setParentActivityResponse] = useState<Activity | null>(null);
  const [activityNotFound, setActivityNotFound] = useState(false);
  const [loading, setLoading] = useState(true);
  const [bookmarkSuccess, setBookmarkSuccess] = React.useState(false);
  const [toggleMapValue, setToggleMapValue] = useState(false);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const consentPending = useAppSelector(state => state.authentication.consentPending);
  const isAuthenticatedAndConsented = isAuthenticated && !consentPending;
  const eventType = useAppSelector(state => state.homeActivity.eventType);
  const leaveActivityType = useAppSelector(state => state.leaveActivityReducer.success);
  const reportActivity = useAppSelector(state => state.reportActivityReducer.success);
  const [volunteerButtonClick, setvolunteerButtonClick] = useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [likeSuccess, setLikemarkSuccess] = React.useState(false);
  const [blockedParticipant, setblockedParticipant] = React.useState(false);
  const makeModeratorSuccess = useAppSelector(state => state.activitParticipants.success);

  const isSmallScreen = useMediaQuery('(max-width:767px)');
  const breakPoint = useMediaQuery('(max-width:988px)');
  const handleButtonClicked = () => { };
  const handleButtonMapClicked = () => { };
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isDarkMode = theme.palette.mode === 'dark';
  const [childrens, setChildrens] = React.useState<any>([]);
  const [newChildrens, setNewChildrens] = React.useState<any>([]);
  const [newChildrensDates, setNewChildrensDates] = React.useState<any>([]);

  const smallScreenStyles = {
    border: 'none',
  };

  const largeScreenStyles = {
    height: '85vh',
    overflowY: 'scroll',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '&::-webkit-scrollbar-thumb': { backgroundColor: 'secondary.contrastText', height: '10px' },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
  };

  const styles = {
    ...(isSmallScreen || breakPoint ? smallScreenStyles : largeScreenStyles),
  };

  const authTokenFromStorage = (async () => {
    try {
      const authToken = await getAccessToken();
      if (authToken) {
        return authToken;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  })();
  (async () => {
    token = await authTokenFromStorage;
  })();
  const [hasNavigated, setHasNavigated] = useState(false);
  const isNavigating = useRef(false);

  useEffect(() => {
    // Check only once on mount - prevents location changes from triggering re-checks
    const canGoBack = window.history.length > 1 &&
      (window.history.state?.idx > 0 || document.referrer !== '');
    setHasNavigated(canGoBack);
  }, []); // Empty array - runs only once, prevents view count inflation

  const handleGoBack = () => {
    metaTagUpdateReverse();
    isNavigating.current = true; // Block view count
    navigate(-1);
  };

  const handleSubCategoryClick = (category: string, subCategory: string) => {
    setCategory(category);
    setSubCategory(subCategory);
  };

  const handleAccordionClick = (categoryId: any, currentState: any) => {
    setCategory(categoryId);
  };

  const handleBookmarkSuccess = () => {
    setBookmarkSuccess(s => !s);
  };

  const handleLikeSuccess = () => {
    setLikemarkSuccess(s => !s);
  };

  const handleVolunteerButtonClick = value => {
    setvolunteerButtonClick(value);
  };

  const handleIsSubmitClicked = value => {
    setIsSubmitClicked(value);
  };

  const handleParticipantBlocked = value => {
    setblockedParticipant(value);
  };

  const handleButtonFeatureClicked = () => { };

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  }));
  const drawer = (
    <Box
      sx={{
        border: 'none',
        height: '100vh',
        overflowY: 'scroll',
        overflowX: 'hidden',
        background:
          theme.palette.mode === 'dark'
            ? theme.palette.background.default
            : 'transparent linear-gradient(133deg, #F7F5EF 35%, #F2F2FA 58%, #EFEFF5 100%) 0% 0% no-repeat padding-box',

        maxWidth: { sm: drawerWidthSm, lg: drawerWidth, md: drawerWidthSm },
        backdropFilter: 'blur(10px)',

        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'secondary.contrastText', height: '10px' },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
      }}
    >
      {consentPending && <Box sx={{ height: '44px', flexShrink: 0 }} />}
      <DrawerHeader sx={{ justifyContent: 'center', height: '79px', border: 'none' }}>
        <Link id="RouterNavLink" to={'/'} style={{ paddingLeft: '0px', paddingRight: '50px' }}>
          <AmyIcon sx={{ width: '159px', height: '100px' }} />
        </Link>
      </DrawerHeader>

      <SideNavigation
        category={category}
        subCategory={subCategory}
        onSubCategoryClick={handleSubCategoryClick}
        onhandleAccordionClick={handleAccordionClick}
        onButtonClicked={handleButtonClicked}
        onMapClicked={handleButtonMapClicked}
        toggleMapValue={toggleMapValue}
        setToggleMapValue={setToggleMapValue}
        onFeatureClicked={handleButtonFeatureClicked}
      />
      <Divider />
    </Box>
  );

  const container = window.document.body;

  useEffect(() => {
    dispatch(updateVolunteeringEventId(activityId));
  }, [activityId]);
  const [dataFromChild, setDataFromChild] = useState(null);
  const handleDataChange = newData => {
    setDataFromChild(newData);
    setactivityRespectiveId(newData);
    fetchActivitiesInfo(newData);
  };
  // Function to call view count API
  const fetchViewCount = async (activityId: string) => {
    const myDetailsAccount = localStorage.getItem('MyDetailsAccount');
    const userId = myDetailsAccount ? JSON.parse(myDetailsAccount)?.id : null;

    try {
      if (isAuthenticated && userId) {
        await axios.post(`api/activities/${activityId}/add-view?userId=${userId}`);
      } else {
        await axios.post(`api/unauthorized/activities/${activityId}/add-view`);
      }
    } catch (error) {
      console.error('Error updating view count:', error);
    }
  };

  // Track the last location key to ensure view count increments on each page visit
  const lastLocationKey = useRef<string | null>(null);

  // Separate useEffect for view count - runs when user enters the details page
  useEffect(() => {
    if (isNavigating.current) return; // Skip if navigating away

    const currentLocationKey = location.key || location.pathname;
    if (activityId !== undefined && lastLocationKey.current !== currentLocationKey) {
      fetchViewCount(activityId);
      lastLocationKey.current = currentLocationKey;
    }
  }, [activityId, location.key, location.pathname, isAuthenticated]);

  useEffect(() => {
    const fetchData = async () => {
      if (activityId !== undefined) {
        try {
          if (isAuthenticatedAndConsented) {
            const response = await dispatch(fetchRecurringDetails(activityId));
            // Access the response data here()
            setChildrens(response?.payload);
          } else {
            const response = await dispatch(fetchUnAuthRecurringDetails(activityId));
            // Access the response data here()
            setChildrens(response?.payload);
          }
        } catch (error) {
          console.error('Recurring failed:', error);
        }
      }
    };

    fetchData();
  }, [activityId]);

  useEffect(() => {
    const fetchDataDates = async () => {
      if (activityId !== undefined) {
        try {
          if (isAuthenticatedAndConsented) {
            const response = await dispatch(fetchRecurringDetails(activityId));
            // Access the response data here()
            if (response.meta.requestStatus === 'fulfilled') {
              if (Array.isArray(response.payload) && response.payload.length === 0) {
                setActivityNotFound(true);
              } else {
                setNewChildrensDates(response.payload);
                setActivityNotFound(false);
              }
            }
          } else {
            const response = await dispatch(fetchUnAuthRecurringDetails(activityId));
            // Access the response data here()
            setNewChildrensDates(response?.payload);
          }
        } catch (error) {
          console.error('Recurring failed:', error);
        }
      }
    };

    fetchDataDates();
  }, [activityId, volunteerButtonClick, leaveActivityType, dataFromChild]);

  useEffect(() => {
    const fetchData = async () => {
      if (activityId !== undefined) {
        try {
          if (isAuthenticatedAndConsented) {
            const response = await dispatch(fetchRecurringDetailsFilter({ id: activityId, filterType: 'VOLUNTEER' }));
            if (response) {
              const responsePayload = response?.payload as Array<{
                id: number;
                startDate: string;
                startTime: string;
                endTime: string;
                activityStatus: string;
                parentActivityStatus: string;
                disable: null | boolean;
                parent: boolean;
                participant: boolean;
                organizer: boolean;
              }>;
              const sortedResponse = responsePayload?.sort((a, b) => {
                if (a.parent && !b.parent) return -1;
                if (!a.parent && b.parent) return 1;
                return 0;
              });
              setNewChildrens(sortedResponse);
            }
          } else {
            const response = await dispatch(fetchUnAuthRecurringDetails(activityId));

            setNewChildrens(response?.payload);
          }
        } catch (error) {
          console.error('Recurring failed:', error);
        }
      }
    };

    fetchData();
  }, [activityId, volunteerButtonClick, leaveActivityType, dataFromChild]);

  useEffect(() => {
    if (childrens) {
      const filteredData = childrens.filter(item => !item.parent);

      // Check if there are any participants
      const hasParticipants = filteredData.some(item => item.participant);

      const sortedData = filteredData
        .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime())
        .filter(item => new Date(item.startDate).getTime() > Date.now());

      if (Array.isArray(sortedData) && sortedData.length > 0) {
        const now = Date.now();

        const nextActivity = sortedData.find(item => new Date(item.startTime).getTime() > now);

        if (nextActivity) {
          setactivityRespectiveId(nextActivity.id);
        } else {
          const mostRecentPastActivity = sortedData.reduce((closest, item) => {
            const itemTime = new Date(item.startTime).getTime();
            return itemTime < now && (!closest || itemTime > new Date(closest.startTime).getTime()) ? item : closest;
          }, null);
          if (mostRecentPastActivity) {
            setactivityRespectiveId(mostRecentPastActivity.id);
          }
        }
      } else if (Array.isArray(filteredData) && filteredData.length > 0) {
        const now = Date.now();

        const nextActivity = filteredData.find(item => new Date(item.startTime).getTime() > now);

        if (nextActivity) {
          setactivityRespectiveId(nextActivity.id);
        } else {
          const mostRecentPastActivity = filteredData.reduce((closest, item) => {
            const itemTime = new Date(item.startTime).getTime();
            return itemTime < now && (!closest || itemTime > new Date(closest.startTime).getTime()) ? item : closest;
          }, null);
          if (mostRecentPastActivity) {
            setactivityRespectiveId(mostRecentPastActivity.id);
          }
        }
      } else {
        console.log('No valid data in sortedData or filteredData');
      }
    }
  }, [childrens, activityId]);

  const fetchActivitiesInfo = async (id: any) => {
    console.log('activityRespectiveId', activityRespectiveId);
    setLoading(true);

    try {
      let response;

      if (isAuthenticatedAndConsented) {
        response = await dispatch(fetchActivityDetails(id));
      } else {
        response = await dispatch(fetchActivityDetailsUnauthorized(id));
      }

      if (response.meta.requestStatus === 'fulfilled') {
        useMetaTagUpdater(response.payload);
        setActivity(response.payload);
        setIsSubmitClicked(false);
        setActivityNotFound(false);
      } else if (response.meta.requestStatus === 'rejected') {
        console.error('Error fetching activity details:', response.error);
        setActivityNotFound(true);
      }
    } catch (error) {
      console.error('Unexpected error in fetchActivitiesInfo:', error);
      setActivityNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activityRespectiveId) {
      fetchActivitiesInfo(activityRespectiveId);
    }
    return () => {
      toast.dismiss('activity-fetch-error');
    };
  }, [
    isAuthenticated,
    isSubmitClicked,
    bookmarkSuccess,
    likeSuccess,
    reportActivity,
    makeModeratorSuccess,
    blockedParticipant,
    activityRespectiveId,
  ]);
  const handleDeleteClick = async (id: string) => {
    try {
      const response = await dispatch(deleteActivityByIds({ activityIds: [id], organizationId: 0, message: '' }));
      if (typeof response.payload === 'string') {
        try {
          if (authTokenFromStorage) {
            dispatch(fetchActivities({ eventType: eventType }));
            navigate('/');
          } else {
            dispatch(fetchunAuthorosiedActivities({ eventType: eventType }));
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDataUpdate = dataFromChild => {
    setactivityRespectiveId(dataFromChild);
    fetchActivitiesInfo(dataFromChild);
  };

  const handleUpdateData = (data: any) => {
    setActivity(data);
  };
  return (
    <Box
      sx={{
        display: 'flex',
        background: isDarkMode ? '#1F1F26' : 'transparent linear-gradient(118deg, #F7F5EF 0%, #F2F2FA 49%, #EFEFF5 100%) 0% 0% no-repeat',
        p: 0,
        border: 'none',
        backdropFilter: 'blur(10px)',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <SEO activity={activity} />
      {/* <Helmet>
        <title>{activity?.title}</title>
        <meta name="description" content={activity?.caption} />
        <meta property="og:title" content={activity?.title} />
        <meta property="og:description" content={activity?.caption} />
      </Helmet> */}
      {/* topnav */}
      <CssBaseline />
      <AppBar
        elevation={0}
        position="fixed"
        sx={{
          top: consentPending ? '44px' : 0,
          width: { sm: `calc(100% - ${drawerWidthSm}px)`, md: `calc(100% - ${drawerWidthSm}px)`, lg: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidthSm}px`, md: `${drawerWidthSm}px`, lg: `${drawerWidth}px` },
          background: isDarkMode ? '#2C2C38' : 'transparent',
        }}
      >
        <Toolbar
          className="amy-top-nav"
          sx={{
            backgroundColor: ' transparent linear-gradient(118deg, #F7F5EF 0%, #F2F2FA 49%, #EFEFF5 100%) 0% 0% no-repeat',
            background: isDarkMode ? '#1F1F26' : '',
            border: 'none',
            backdropFilter: 'blur(10px)',
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' }, top: '10px' }}
          >
            <MenuIcon />
          </IconButton>
          <PrimaryHeader />
        </Toolbar>
      </AppBar>
      {/* Topnav-end */}
      {/* SideNav */}
      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidthSm, md: drawerWidthSm, lg: drawerWidth },
          flexShrink: { sm: 0 },
          minHeight: '100vh',
          border: 'none',
          background: isDarkMode ? '#1F1F26' : 'transparent linear-gradient(118deg, #F7F5EF 0%, #F2F2FA 49%, #EFEFF5 100%) 0% 0% no-repeat',
        }}
        aria-label="activity-detail"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidthSm },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: { sm: drawerWidthSm, md: drawerWidthSm, lg: drawerWidth } },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      {/* SideNav-end */}
      {/* Main section */}
      <Box
        className="inside-bg"
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: '-webkit-fill-available',
        }}
      >
        <div className="row" style={{ padding: 1, marginTop: consentPending ? '106px' : '50px' }}>
          <ArrowCircleLeftIcon
            onClick={() => handleGoBack()}
            sx={{
              cursor: 'pointer',
              color: isDarkMode ? '#FFCE00' : '#775fff',
              borderRadius: '50%',
              fontSize: '50px',
              marginLeft: '10px',
              opacity: hasNavigated ? 1 : 0.5,
              pointerEvents: hasNavigated ? 'auto' : 'none',
            }}
          />
        </div>

        <Box
          className="p-3"
          sx={{
            background: isDarkMode ? '#1F1F26' : '',
            height: '77vh',
            overflowY: 'scroll',
            overflowX: 'hidden',

            // overflow: 'auto',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}
        >
          <div className="row screen-space">
            <div className={`col-md-${breakPoint ? '12' : '8'}`} style={{ paddingLeft: '0px !important' }}>
              <Box sx={styles}>
                {activityNotFound && (
                  <Box
                    display="flex"
                    height="60vh"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      padding: '24px',
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        borderRadius: '8px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        maxHeight: { xs: 300, md: 200 },
                        maxWidth: { xs: 400, md: 300 },
                      }}
                      alt="No activity found illustration"
                      src="content/images/empty.svg"
                    />
                    <Typography
                      fontSize="24px"
                      mt={3}
                      fontWeight="bold"
                      sx={{
                        color: isDarkMode ? '#FFCE00' : '#4A4A4A',
                        textAlign: 'center',
                      }}
                    >
                      Activity Not Found
                    </Typography>
                    <Typography
                      fontSize="16px"
                      mt={1}
                      color={isDarkMode ? '#BFBFBF' : '#757575'}
                      sx={{
                        textAlign: 'center',
                      }}
                    >
                      Sorry, the activity you're looking for doesn't exist or has been removed.
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{
                        mt: 4,
                        background: isDarkMode ? '#FFCE00' : '#674BFF',
                        color: '#fff',
                        borderRadius: '20px',
                        padding: '10px 24px',
                        textTransform: 'none',
                        fontWeight: '600',
                        '&:hover': {
                          background: isDarkMode ? '#FFC800' : '#563ECC',
                        },
                      }}
                      onClick={() => window.location.replace('/')}
                    >
                      Back to Home
                    </Button>
                  </Box>
                )}

                <ActivityRecurringDetails
                  activityResponse={activity}
                  childrensResponse={childrens}
                  onBookmarkSuccess={handleBookmarkSuccess}
                  onLikeSuccess={handleLikeSuccess}
                  handleDeleteClick={handleDeleteClick}
                  onParticipantBlocked={handleParticipantBlocked}
                  onDataUpdate={handleDataUpdate}
                  onDataChange={handleDataChange}
                  dateResponse={newChildrensDates}
                  setNewData={handleUpdateData}
                />
              </Box>
            </div>
            <div className={`col-md-${breakPoint ? '12' : '4'}`}>
              <div
                style={{
                  background: isDarkMode ? '#2C2C38' : '#FFFFFF',
                  borderRadius: '15px',
                  marginTop: isSmallScreen || breakPoint ? '2%' : '0',
                }}
              >
                <RecurringDetailsSidePanel
                  activityResponse={activity}
                  volunteerButtonClick={volunteerButtonClick}
                  isSubmitClicked={isSubmitClicked}
                  onVolunteerButtonClick={handleVolunteerButtonClick}
                  onIsSubmitClicked={handleIsSubmitClicked}
                  childrensResponse={newChildrens}
                  onDataChange={handleDataChange}
                />
              </div>
            </div>
          </div>
        </Box>
      </Box>
      {/* main-end */}
    </Box>
  );
};
export default RecurringSection;

